"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * *1 prettier-ignore note:
 *
 * something like `TUnk extends (infer U extends object) | undefined ? <...> : never`
 * will type `U` as the object-part of `TUnk` if `TUnk` extends `object | undefined`.
 * For example, if `TUnk = { id: string } | undefined` then `U = { id: string }`.
 * Prettier, however, when formatting will remove these parenthases, resulting in
 * `TUnk extends infer U extends object | undefined ? <...> : never.
 *
 * In this case, if `TUnk = { id: string } | undefined`, then `U` would get typed
 * as `{ id: string } | undefined`, which is /not/ the behavior we desire.
 */
